import {
  AssetLibraryManager,
  Component,
  RuntimeComponent,
  RuntimeScene,
  SceneManager,
  VirtualChildComponent,
} from '@easytwin/runtime';
import * as React from 'react';
import { Select, SelectProps } from '@easyv/react-components';

interface TextureSelectionProps extends SelectProps {
  comp: RuntimeComponent | RuntimeScene;
}

export function TextureSelection(props: TextureSelectionProps) {
  const { comp, ...rest } = props;

  const textures =
    (comp instanceof RuntimeScene ? comp : comp.scene)
      ?.getManager(AssetLibraryManager)
      ?.getTextureListVO() || [];

  return (
    <Select
      showSearch
      allowClear
      placeholder='搜索贴图'
      size='small'
      {...props}
      triggerProps={{ position: 'bottom' }}
      filterOption={(inputValue, option) => {
        return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
      }}
      {...rest}
    >
      {textures.map((item) => (
        <Select.Option key={item.uuid} value={item.uuid}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  );
}
